import { useSelector } from 'react-redux';
import useUpdateSelectedImages from '../actions/useUpdateSelectedImages';

export default function useSelectedImages() {
  return {
    updateSelectedImages: useUpdateSelectedImages(),
    selectedImages: useSelector(state => state.layout.selectedImages)
  };
}
